import { Table, Box, Avatar, ActionIcon, Text } from "@axazara/raiton-atoms";
import { SearchStatusOutline } from "@axazara/raiton-icons";
import { Link } from "react-router-dom";
import { User, formatDate } from "utilities";

export function UserTableRow({ user }: { user: User }) {
  return (
    <Table.Row key={user?.id}>
      <Table.Cell className="text-p-01-medium text-neutral-40">
        {user?.id}
      </Table.Cell>
      <Table.Cell>
        <Box className="md:flex-row flex flex-col items-center space-x-4">
          <Avatar src={user?.profile_photo_url} size={32} />
          <Box>
            <Text className="text-p-01-semibold">
              {user?.first_name} {user?.last_name}
            </Text>
            <Text className="text-caption-medium text-neutral-40">
              {user?.email}
            </Text>
          </Box>
        </Box>
      </Table.Cell>
      <Table.Cell className="text-neutral-40 text-p-01-medium">
        {formatDate(user?.created_at, "en", "D MMM YYYY, HH:mm")}
      </Table.Cell>
      <Table.Cell>
        <Box
          component={Link}
          to={`/users/${user.id}`}
          className="flex space-x-2 justify-end"
        >
          <ActionIcon color="primary" className="p-0.5" size="xl" radius={100}>
            <SearchStatusOutline className="w-6 h-6 text-primary-50" />
          </ActionIcon>
        </Box>
      </Table.Cell>
    </Table.Row>
  );
}
